// extracted by mini-css-extract-plugin
module.exports = {"container":"infoCards_container__13aF9","cardTitle":"infoCards_cardTitle__23lCX","copy":"infoCards_copy__3idKw","div":"infoCards_div__17m5x","readmore":"infoCards_readmore__2RQ72"};